<div class="review-top">
  <div class="review-summary is-flex has-flex-align-center hide-on-mobile">
    <span translate="reviews.num-reviews" [translateParams]="{ num: reviews.length }"></span>
    <app-rating [setRating]="rating.overall_rating"></app-rating>
  </div>
  <a [href]="rating.profile_url" translate="reviews.powered-by" target="_blank" rel="noopener"></a>
  <div class="review-container">
    <div *ngFor="let review of (reviews | slice: currentPage*pageSize: pageSize*(currentPage+1) )" class="review">
      <h4 class="reviewer">{{ review.author }}</h4>
      <app-rating [setRating]="review.overall_rate"></app-rating>
      <div class="content" [class.collapsed]="!review['more']" #content>{{ review.content }}</div>
      <button *ngIf="content.clientHeight >= 142" class="more btn-link" [translate]="'reviews.read-' + (review['more'] ? 'less' : 'more')" (click)="review['more'] = !review['more']"></button>
    </div>
    <app-pagination [totalPages]="totalPages" [currentPageNumber]="currentPage" (onChangePage)="currentPage=$event"
      [showTextPages]="(communicationService.screenSize | async) !== SCREEN_SIZE.MOBILE_ONLY" [disableSEO]="true"></app-pagination>
  </div>
</div>